(function () {
        const body = document.body;
        const openButton = document.querySelector(".nav__menu-button");
        const closeButton = document.querySelector(".sidebar__close");
        const backdrop = document.querySelector(".backdrop");
        const sidebarLinks = document.querySelectorAll(".sidebar__menu a");
        const searchButton = document.querySelector(".nav__search");
        const searchPanel = document.querySelector(".search-panel");
        const searchInput = document.querySelector(".search-panel__input");
        const searchCancel = document.querySelector(".search-panel__cancel");
        const searchForm = document.querySelector(".search-panel__form");
        const regionToggle = document.querySelector(".sidebar__region-toggle");
        const regionSection = document.querySelector(
          ".sidebar__section--region"
        );
        const regionListWrapper = document.querySelector(
          ".sidebar__region-list-wrapper"
        );
        const regionSelectedLabel = document.querySelector(
          "[data-region-selected]"
        );
        const regionOptions = document.querySelectorAll(
          ".sidebar__region-option"
        );
        const footerRegionLabel = document.querySelector(
          "[data-footer-region]"
        );

        const setRegionExpanded = (expanded) => {
          if (!regionSection || !regionListWrapper || !regionToggle) return;
          regionSection.classList.toggle("is-open", expanded);
          regionToggle.setAttribute(
            "aria-expanded",
            expanded ? "true" : "false"
          );
          regionListWrapper.hidden = !expanded;
        };

        const setActiveRegion = (option) => {
          if (!option) return;
          regionOptions.forEach((btn) => btn.classList.remove("is-active"));
          option.classList.add("is-active");
          if (regionSelectedLabel) {
            const region = option.dataset.region || option.textContent.trim();
            const currency = option.dataset.currency
              ? ` (${option.dataset.currency})`
              : "";
            regionSelectedLabel.textContent = `${region}${currency}`;
          }
          if (footerRegionLabel) {
            const region = option.dataset.region || option.textContent.trim();
            const currency = option.dataset.currency
              ? ` (${option.dataset.currency})`
              : "";
            footerRegionLabel.textContent = `${region}${currency}`;
          }
        };

        const openMenu = () => {
          closeSearch();
          body.classList.add("is-menu-open");
          setRegionExpanded(false);
        };
        const closeMenu = () => {
          body.classList.remove("is-menu-open");
          setRegionExpanded(false);
        };
        const toggleMenu = () =>
          body.classList.contains("is-menu-open") ? closeMenu() : openMenu();

        const openSearch = () => {
          closeMenu();
          body.classList.add("is-search-open");
          searchPanel?.setAttribute("aria-hidden", "false");
          requestAnimationFrame(() => {
            searchInput?.focus();
          });
        };

        const closeSearch = () => {
          if (!body.classList.contains("is-search-open")) return;
          body.classList.remove("is-search-open");
          searchPanel?.setAttribute("aria-hidden", "true");
          searchInput?.blur();
          searchButton?.focus();
        };

        if (regionSection && regionToggle) {
          setRegionExpanded(true);
        }

        openButton?.addEventListener("click", toggleMenu);
        closeButton?.addEventListener("click", closeMenu);
        searchForm?.addEventListener("submit", (event) => {
          event.preventDefault();
        });
        searchButton?.addEventListener("click", () => {
          if (body.classList.contains("is-search-open")) {
            closeSearch();
          } else {
            openSearch();
          }
        });
        searchCancel?.addEventListener("click", closeSearch);
        backdrop?.addEventListener("click", () => {
          closeMenu();
          closeSearch();
        });

        regionToggle?.addEventListener("click", () => {
          if (!regionSection) return;
          const expanded = !regionSection.classList.contains("is-open");
          setRegionExpanded(expanded);
        });

        regionOptions.forEach((option) =>
          option.addEventListener("click", () => {
            setActiveRegion(option);
            setRegionExpanded(false);
          })
        );

        sidebarLinks.forEach((link) =>
          link.addEventListener("click", () => {
            closeMenu();
          })
        );

        document.addEventListener("keydown", (event) => {
          if (event.key === "Escape") {
            closeMenu();
            closeSearch();
            setRegionExpanded(true);
          }
        });

        // set initial active region
        const initialActive = document.querySelector(
          ".sidebar__region-option.is-active"
        );
        if (initialActive) {
          setActiveRegion(initialActive);
        }

        // collapse by default
        setRegionExpanded(false);
      })();